<template>
  <div style="width: 100%;">
    <span>付款渠道</span>
    <div style="width:100%;display: flex;" class="five">
      <div id="fivecopy2" style="width:100%; height:200px">
      </div>
    </div>

 <el-dialog  title="成单分析详情" center append-to-body :close-on-click-modal="false" :visible.sync="isTable"   width="80%"  :before-close="handleisShowRepresentative">
    <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"  :cell-style="{ 'text-align': 'center' }" :data="list" border height="700"  >
      <el-table-column prop="customerId" label="订单号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="regionName" label="城市" show-overflow-tooltip></el-table-column>
      <el-table-column prop="studentName" label="学生姓名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="gradeName" width="180" label="年级" show-overflow-tooltip></el-table-column>
      <el-table-column prop="saleName" label="销售" show-overflow-tooltip></el-table-column>
      <el-table-column prop="diagnoseTeacherName" label="诊断师"></el-table-column>
      <el-table-column prop="projectTeacherName" label="规划师"></el-table-column>
      <el-table-column prop="classTypeName" label="学生类型" show-overflow-tooltip></el-table-column>
      <el-table-column prop="customerSourceName" label="来源" show-overflow-tooltip></el-table-column>
      <el-table-column prop="payAlltypeName" width="200" label="付款渠道" show-overflow-tooltip></el-table-column>
      <el-table-column prop="sumMoney" width="130" label="金额" show-overflow-tooltip></el-table-column>
      <el-table-column prop="costTypeName" label="客资类型" show-overflow-tooltip></el-table-column>
      <el-table-column prop="periodsNumber" label="期数" show-overflow-tooltip></el-table-column>
      <el-table-column prop="incomeTypeName" label="收支类型" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" width="200" label="创建时间" show-overflow-tooltip></el-table-column>
    </el-table>

    <el-pagination 
      layout="prev, pager, next,sizes, jumper" 
      @size-change="handleSizeChange" 
      @current-change="handleCurrentChange" 
      :current-page="pageNum" 
      :page-size="pageSize"
      :total="total" 
      style="text-align: end;padding-top: 30px;">
    </el-pagination>


 </el-dialog>
    

  </div>
</template>

<script>
import * as echarts from 'echarts';
import axios from 'axios'
import apiBaseUrl from '../../../config/api'
export default {
  props:{
    list4:Array,
    times: Array,
  },
  name: "",
  data() {
    return {
      myChart: null,
      isTable: false,
      list:[],

      total: 0,
      pageNum: 1,
      pageSize: 10,

      id:'',
    }
  },
  mounted() {
    this.initBie()
  },
  methods: {

    handleSizeChange(val) {
      this.pageSize = val
      this.handlesourceDetail()
    },

    handleCurrentChange(val) {
      this.pageNum = val
      this.handlesourceDetail()
    },

    handleisShowRepresentative(){
      this.isTable = false
      this.id = ''
      this.list = []
      this.pageNum = 1
      this.pageSize = 10
    },

    handlesourceDetail(){
        let data = {
          payAllType: this.id,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          time: this.times,
        }
        axios.post(`${apiBaseUrl}/stat/paymentChannelsDetail`,data,{headers:{'authorization': sessionStorage.getItem('tokenInfo')}, }).then(res => {
          if (res.data.code == 200) {
            this.list = res.data.data && res.data.data.records
            this.total = res.data.data && res.data.data.total
          } else {
            this.list = []
            this.total = 0
            this.$message({ message: res.data.message || res.data.msg , type: "error"  });
          }
        }).catch(error => {
          this.list = []
          this.total = 0
          this.$message({ message: error,  type: "error"  });
        });
    },

    initBie() {
      let chartDom = document.getElementById('fivecopy2');
      this.myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#F5D5DC',
          '#E5195A',
          '#fc8452',
          '#9a60b4'],
        title: {
          text: '',
          // subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: '50%',
            data: this.list4,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };

      option && this.myChart.setOption(option);

      this.myChart.on('click', (params) => {
        let { id } = params.data;
        if(id){
          this.id = id
          this.isTable = true;
          this.handlesourceDetail();
        }
      });
      // window.onresize = function () {
      //   myChart.resize();
      // }

    }
  },
  watch: {
    list4: {
      deep: true,
      handler (val) {
        this.initBie()
      },
    },
  },
  components: {

  },
}
</script>

<style scoped>
.five {
  padding-left: 20px;
}
</style>




// WEBPACK FOOTER //
// src/statistics/components/income4copy2.vue